import React from 'react';
import Spinner from '../loaders/spinner';
import '../../../css/buttons.css';
import LazyImage from '../lazyLoad';
const Button = ({
  text,
  textComponent,
  img,
  text2,
  onClick,
  disabled,
  type,
  isLoading,
  imgPosition,
  animate = false,
  disabledFunction = undefined,
  spinnerColor = '#ffffff',
}) => {
  return (
    <div
      onClick={!disabled ? onClick : disabledFunction}
      className={`custom-button-class pointer gap-2 ${animate ? 'animate' : ''} ${type} ${
        disabled ? 'disabled-button' : ''
      } ${text2 ? 'flexBox' : ''}`}>
      {img && imgPosition !== 'right' && <LazyImage src={img} alt='ButtonImg' />}
      {text && <div className={text2 ? 'flexLeft ml-2' : ''}>{text}</div>}
      {textComponent || null}
      {img && imgPosition == 'right' && <LazyImage src={img} alt='ButtonImgRight' />}

      {text2 && <div className='mr-2'>{text2}</div>}
      {isLoading && <Spinner size='25px' stroke='3.2px' spinnerColor={spinnerColor} />}
    </div>
  );
};

export default Button;
